export const stripTags = (value: string): string => {
  return value.replace(/(<([^>]+)>)/gi, "");
};
